import { render, staticRenderFns } from "./mentionlist.vue?vue&type=template&id=05b8bd4a&scoped=true"
import script from "./mentionlist.vue?vue&type=script&lang=js"
export * from "./mentionlist.vue?vue&type=script&lang=js"
import style0 from "./mentionlist.vue?vue&type=style&index=0&id=05b8bd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b8bd4a",
  null
  
)

export default component.exports